import { render, staticRenderFns } from "./ContractCalls.vue?vue&type=template&id=74c1fcfc"
import script from "./ContractCalls.vue?vue&type=script&lang=js"
export * from "./ContractCalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports